import { getManifestByName } from '@/scripts/pages/video/Player/InPlayerOverlays/implementation/manifest';
import { ControlInterfaceOptions, FilmReviewServiceUiMethods } from './types';
import { VideoPlayerActionContext } from '../../../types';
import { FilmReviewServiceName } from '../filmReviewService';
import { destroyService } from '../../services';

type Ctx = VideoPlayerActionContext;

const FilmReviewInPlayerOverlayManifest = {
  hint: getManifestByName('FilmReviewHint'),
  questions: getManifestByName('FilmReviewQuestions'),
};

const VoidAction = (): void => {
  // do nothing
};

export const createFilmReviewServicePresenterMethods = (context: Ctx | null): FilmReviewServiceUiMethods => {
  if (context === null) {
    return {
      controlInterface: VoidAction,
      requestToNotShow: VoidAction,
    };
  }

  const controlInterface = (options: ControlInterfaceOptions): void => {
    let draft = context.state.controls.inPlayerOverlays.slice();

    if (options.hint === true) {
      draft = draft.concat(FilmReviewInPlayerOverlayManifest.hint);
    } else if (options.hint === false) {
      draft = draft.filter(x => x !== FilmReviewInPlayerOverlayManifest.hint);
    }

    if (options.questions === true) {
      draft = draft.concat(FilmReviewInPlayerOverlayManifest.questions);
    } else if (options.questions === false) {
      draft = draft.filter(x => x !== FilmReviewInPlayerOverlayManifest.questions);
    }

    context.commit('setInPlayerOverlays', draft);
  };

  return {
    controlInterface,
    requestToNotShow(): void {
      destroyService(context, FilmReviewServiceName);
    },
  };
};
